import { implementSetAllNavTabDetailsMutation } from "../../../../dt-plugins/sidewindow/nav-tab";
import * as types from "./types";

// Mutations Object for ProjectsCatalog. Use it by importing projects/types.js and calling commit() from  projects/actions.js Action File.
export const projectsCatalogMutations = {
  [types.ProjectsCatalogData.SET.ALL](state, payload) {
    state.projectsCatalogData = payload;
  },
  [types.ProjectList.SET.ALL](state, payload) {
    state.projectList = payload; // { tracks: []}
    console.log("state.projectList from mutations payload", payload);
    console.log("state.projectList from mutations ", state.projectList);
    // state.projectList = {}
  },
  [types.ProjectRelatedContacts.SET.ALL](state, payload) {
    state.projectDetails.contact_relations = payload;
  },
  ...implementSetAllNavTabDetailsMutation(
    types.ProjectDetails,
    "projectDetails"
  )
};
